import React from 'react';
import Request from '@its/components/lib/Request';
import formBuilder from '@its/components/lib/Container components/FormContainer/FormContainer';
import {
  setVisibility,
} from '@its/components/lib/Container components/LoadingContainer/actions';
import {
  setSuccessSnackBar,
  setErrorSnackBar,
} from '@its/components/lib/Container components/SnackBarContainer/actions';
import {
  setAppBar,
} from '@its/components/lib/Container components/DrawerMenuContainer/actions';
import { goBack } from 'react-router-redux';
import {
  handleTemplateList,
  handleTimerList,
  handleDepartmentList,
} from './util';
import { ipAddress, macAddress, version } from '@its/util/lib/regexp';
import {
  getTemplates,
  getTimers,
  getDepartments,
} from '../../api';
import { ipConverter, merge } from '@its/util';
import {
  cancelText,
  saveText,
  nameText,
} from '@its/components/lib/util/i18n';
import {
  generalDataText,
  TechnicalDataText,
  ExampleName,
  ShortDescription,
  ExampleLocation,
  Location,
  ExampleTechnicalName,
  TechnicalName,
  Template,
  Timer,
  IsActive,
  Notes,
  ExampleIpAddress,
  Ipv4LAN1,
  ExamplePort,
  PortLAN1,
  ExampleMacAddress,
  InvalidIpAddress,
  InvalidMacAddress,
  InvalidVersion,
  MacAddressLAN1,
  MacAddressLAN2,
  Ipv4LAN2,
  PortLAN2,
  ExampleSerialNumber,
  SerialNumber,
  ExampleFirmwareVersion,
  FirmwareVersion,
  FrameNumber,
  ExampleNumber,
  Department,
} from '../../i18n/intl';

const formatValues = (values) => {
  if (values.iPv4_LAN1 && values.iPv4_LAN2) {
    values.iPv4_LAN1 = ipConverter.toInt(values.iPv4_LAN1);
    values.iPv4_LAN2 = ipConverter.toInt(values.iPv4_LAN2);
  }
  if (values.macAddress_LAN1 === '') {
    values.macAddress_LAN1 = null;
  }
  if (values.macAddress_LAN2 === '') {
    values.macAddress_LAN2 = null;
  }
  return values;
};

export const displayFormConfig = {
  submitText: saveText,
  cancelText,
  groups: [
    {
      key: 'generalData',
      title: generalDataText,
      fields: {
        name: {
          hintText: ExampleName,
          floatingLabelText: nameText,
          validators: {
            required: true,
            maxLength: 128,
          },
        },
        shortDescription: {
          floatingLabelText: ShortDescription,
          validators: {
            required: true,
            maxLength: 250,
          },
        },
        location: {
          hintText: ExampleLocation,
          floatingLabelText: Location,
          validators: {
            required: true,
            maxLength: 250,
          },
        },
        technicalName: {
          hintText: ExampleTechnicalName,
          floatingLabelText: TechnicalName,
          validators: {
            required: true,
            maxLength: 250,
          },
        },
        frames: {
          hintText: ExampleNumber,
          floatingLabelText: FrameNumber,
          validators: {
            type: 'number',
            required: true,
            min: 1,
          },
        },
        templateId: {
          type: 'select',
          floatingLabelText: Template,
          items: [],
          autoWidth: true,
          newLine: true,
          validators: {
            required: true,
          },
        },
        iterationId: {
          type: 'select',
          floatingLabelText: Timer,
          items: [],
          autoWidth: true,
          validators: {
            required: true,
          },
        },
        departmentId: {
          type: 'select',
          floatingLabelText: Department,
          items: [],
          autoWidth: true,
        },
        isActive: {
          type: 'toggle',
          label: IsActive,
        },
        notes: {
          type: 'textArea',
          newLine: true,
          floatingLabelText: Notes,
        },
      },
    }, {
      key: 'technicalData',
      title: TechnicalDataText,
      fields: {
        iPv4_LAN1: {
          hintText: ExampleIpAddress,
          floatingLabelText: Ipv4LAN1,
          validators: {
            regex: {
              value: ipAddress,
              message: InvalidIpAddress,
            },
            required: true,
          },
        },
        port_LAN1: {
          hintText: ExamplePort,
          floatingLabelText: PortLAN1,
          validators: {
            type: 'number',
            required: true,
            min: 1,
            max: 65536,
          },
        },
        macAddress_LAN1: {
          hintText: ExampleMacAddress,
          floatingLabelText: MacAddressLAN1,
          validators: {
            regex: {
              value: macAddress,
              message: InvalidMacAddress,
            },
          },
        },
        iPv4_LAN2: {
          hintText: ExampleIpAddress,
          floatingLabelText: Ipv4LAN2,
          newLine: true,
          validators: {
            regex: {
              value: ipAddress,
              message: InvalidIpAddress,
            },
            required: true,
          },
        },
        port_LAN2: {
          hintText: ExamplePort,
          floatingLabelText: PortLAN2,
          validators: {
            type: 'number',
            required: true,
            min: 1,
            max: 65536,
          },
        },
        macAddress_LAN2: {
          hintText: ExampleMacAddress,
          floatingLabelText: MacAddressLAN2,
          validators: {
            regex: {
              value: macAddress,
              message: InvalidMacAddress,
            },
          },
        },
        serialNumber: {
          hintText: ExampleSerialNumber,
          floatingLabelText: SerialNumber,
          newLine: true,
          validators: {
            maxLength: 50,
          },
        },
        firmware: {
          hintText: ExampleFirmwareVersion,
          floatingLabelText: FirmwareVersion,
          validators: {
            regex: {
              value: version,
              message: InvalidVersion,
            },
          },
        },
      },
    },
  ],
};

export default class extends React.Component {

  static propTypes = {
    name: React.PropTypes.string.isRequired,
    confirmExit: React.PropTypes.bool,
    initialValues: React.PropTypes.object,
    request: React.PropTypes.func.isRequired,
    onSubmit: React.PropTypes.func,
    onSuccess: React.PropTypes.func,
    children: React.PropTypes.any,
    getLists: React.PropTypes.bool,
    config: React.PropTypes.object,
    appBar: React.PropTypes.object,
  }

  static defaultProps = {
    confirmExit: false,
    getLists: false,
    initialValues: {},
    config: displayFormConfig,
  }

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    if (props.appBar) {
      this.context.store.dispatch(setAppBar(props.appBar));
    }
    let config = Object.assign({}, props.config);
    this.request = props.request;
    const FormContainer = formBuilder({
      name: props.name,
      groups: config.groups,
    });
    config = merge(config, { initialValues: props.initialValues });
    const setConfig = (templateList, timerList, departmentList) => {
      if (config.groups[config.groups.length - 2]) {
        config.groups[config.groups.length - 2].fields.templateId.items = templateList;
        config.groups[config.groups.length - 2].fields.iterationId.items = timerList;
        config.groups[config.groups.length - 2].fields.departmentId.items = departmentList;
      }
    };
    const getComponent = (children, confirmExit) => (
      <div>
        { children }
        <FormContainer
          onCancel={::this.onCancel}
          onSubmit={::this.onSubmit}
          confirmExit={confirmExit}
          submitTop={props.submitTop}
          submitDisabled={props.submitDisabled}
          hideCancel={props.hideCancel}
          {...config}
        />
      </div>
    );
    this.onSuccess = (result, dispatch) => {
      // TODO : connect select with state
      setConfig(
        handleTemplateList(result[0], dispatch),
        handleTimerList(result[1], dispatch),
        handleDepartmentList(result[2], dispatch)
      );
      return getComponent(props.children, props.confirmExit);
    };
    if (!props.getLists) {
      const state = this.context.store.getState();
      setConfig(state.app.templates.list, state.app.timers.list, state.app.departments.list);
      this.component = getComponent(props.children, props.confirmExit);
    }
  }

  onCancel() {
    this.context.store.dispatch(goBack());
  }

  onSubmit(values) {
    const { onSubmit, onSuccess, ...others } = this.props;
    values = formatValues(values);
    values = onSubmit ? onSubmit(values) : values;

    const { dispatch } = this.context.store;
    dispatch(setVisibility(true));
    this.request(values).then((result) => {
      if (onSuccess) {
        onSuccess(result, dispatch, this.props, this.context.store.getState());
      }
      dispatch(setSuccessSnackBar());
    }).catch(() => {
      dispatch(setErrorSnackBar());
    }).finally(() => {
      dispatch(setVisibility(false));
    });
  }

  render() {
    let component;
    if (this.props.getLists) {
      component = (
        <Request
          request={[getTemplates, getTimers, getDepartments]}
          onSuccess={this.onSuccess}
        />
      );
    } else {
      component = this.component;
    }
    return component;
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/DisplayForm.js
 **/